import { Flex, FormLabel } from "@chakra-ui/react";
import * as AF from "src/types/formTemplate";
import { QuestionVisibilitySwitch } from "../../QuestionVisibility";
import { PermissionLevelSwitch } from "../Edit/PermissionLevel";
import { QuestionConstraintsSwitch } from "../Edit/QuestionContraints";
import { QuestionLinkSwitch } from "../Edit/QuestionLink";
import { RequirementSwitch } from "../Edit/Requirement";
import { VerificationSwitch } from "../Edit/Verification";

type Props = {
  questionId: uuid;
  questionType: AF.Question<AF.WithId>["type"];
  hide?: "QuestionVisibility"[];
  verificationOptions?: AF.FormVerification<AF.WithId>[];
};
export const ConfigureQuestion: React.FC<Props> = ({
  questionId,
  questionType,
  hide,
  verificationOptions = [],
}) => {
  return (
    <Flex direction="column" gap="3">
      <FormLabel as="div" margin="0">
        Question configuration
      </FormLabel>
      <VerificationSwitch
        questionType={questionType}
        questionId={questionId}
        verificationOptions={verificationOptions}
      />
      <QuestionLinkSwitch questionId={questionId} />
      <PermissionLevelSwitch
        questionId={questionId}
        questionType={questionType}
      />
      <RequirementSwitch questionType={questionType} questionId={questionId} />
      <QuestionConstraintsSwitch
        questionType={questionType}
        questionId={questionId}
      />
      {!hide?.includes("QuestionVisibility") ? (
        <QuestionVisibilitySwitch questionId={questionId} />
      ) : null}
    </Flex>
  );
};
